import {
  SET_ACTIVE_CLIENT,
  SET_ACTIVE_SURVEY,
  SET_ACTIVE_QUESTION,
} from '../actions/activeSurvey';

// initial state
const INITIAL_STATE = {
  client: null,
  survey: null,
  question: null,
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // create
  case SET_ACTIVE_CLIENT:
    return { ...state, client: action.payload };
  case SET_ACTIVE_SURVEY:
    return { ...state, survey: action.payload };
  case SET_ACTIVE_QUESTION:
    return { ...state, question: action.payload };
  default:
    return state;
  }
};

export default execute;
